module.exports = __webpack_public_path__ + "static/media/VirtualPBX11.e7e953dd.JPG";